export enum GlobalText {
	VariationHigh = "BD070C63-5323-4FF1-96D3-99D16DDCBDA9",
	VariationMedium = "EF9E45CD-C1BC-42F4-94FA-4D26565576DA",
	VariationLow = "1D5ECD15-7817-484F-A4BF-CA2F73D955EC",
	Value = "1C1BBF6F-4697-4657-88C7-C81E020D6B1B",
	InputsCountLabel = "4204247F-DD2C-43DA-8E10-0FA1B15663B2",
}
